var _circle, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemaleIconGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#16C1F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8982 25.4904H10.9893V12.3779L23.8982 11.8044V25.4904Z",
    fill: "#243443"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gender_icon_round_mask",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83501 0 0 7.83502 0 17.5C0 27.165 7.83501 35 17.5 35Z",
    fill: "#36A9E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gender_icon_round_mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0244 30.6396C28.0284 31.6371 26.3211 32.8651 24.187 33.7042C22.0528 34.5433 19.5774 35.0574 17.5 35.0574C15.4226 35.0574 12.9471 34.7017 10.9553 33.7748C8.9634 32.8478 7.54063 32.0647 5.97559 30.6396C6.08964 28.4799 7.3211 25.8676 9.20675 24.6527C10.1496 24.0452 11.4684 23.6383 12.9299 23.3851C14.4405 23.1378 15.9691 23.0185 17.4996 23.0283C20.5181 23.0283 23.905 23.4369 25.7932 24.6527C27.6814 25.8684 28.9103 28.4791 29.0244 30.6396Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0244 30.6396C28.0284 31.6371 26.3211 32.8651 24.187 33.7042C22.0528 34.5433 19.5774 35.0574 17.5 35.0574C15.4226 35.0574 12.9471 34.7017 10.9553 33.7748C8.9634 32.8478 7.54063 32.0647 5.97559 30.6396C6.08964 28.4799 7.3211 25.8676 9.20675 24.6527C10.1496 24.0452 11.4684 23.6383 12.9299 23.3851C14.4405 23.1378 15.9691 23.0185 17.4996 23.0283C20.5181 23.0283 23.905 23.4369 25.7932 24.6527C27.6814 25.8684 28.9103 28.4791 29.0244 30.6396Z",
    fill: "#243443"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7716 22.5907V20.9119H15.2255V22.5907C15.223 22.7672 15.1777 22.9404 15.0935 23.0953C15.0093 23.2502 14.8887 23.382 14.7423 23.4794C14.2988 23.7869 14.0166 24.5337 14.0166 25.2338C14.0166 27.023 15.3404 29.9915 17.4981 29.9915C19.7335 29.9915 20.9797 27.0273 20.9797 25.2338C20.9797 24.5337 20.6975 23.7895 20.254 23.4794C20.1077 23.3819 19.9873 23.25 19.9033 23.0952C19.8192 22.9403 19.774 22.7671 19.7716 22.5907Z",
    fill: "#FBCBAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7711 21.2238V22.799C19.0201 23.2909 18.5816 23.4438 17.8475 23.4438C16.9579 23.4438 16.5017 23.2187 15.3975 22.4345C15.3409 22.3937 15.2851 22.3495 15.2285 22.3113V21.2238C16.2085 21.9035 16.6647 22.1057 17.5011 22.1057C18.3375 22.1057 18.7928 21.9043 19.7711 21.2238Z",
    fill: "#DB9172",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4385 15.9155C21.4385 15.1245 21.8786 14.1611 22.421 14.1611C22.9634 14.1611 23.5193 14.314 23.5193 15.105C23.5193 15.4856 23.3503 16.3386 23.1813 16.7132C23.0022 17.1159 22.7015 17.347 22.421 17.347C21.8786 17.347 21.4385 16.7064 21.4385 15.9155Z",
    fill: "#F7BE9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 7.92767C13.6732 7.92767 12.6299 11.2411 12.6299 15.3352C12.6299 18.048 13.4747 19.9808 15.0461 21.0963C16.1537 21.8805 16.609 22.1048 17.4961 22.1048C18.3874 22.1048 18.8427 21.8805 19.9461 21.0963C21.52 19.9808 22.3631 18.048 22.3631 15.3352C22.3699 11.2436 21.3257 7.92767 17.4995 7.92767Z",
    fill: "#FBCBAB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3473 14.9674C22.306 14.6281 22.1965 14.3009 22.0254 14.0056C22.2014 14.2986 22.3113 14.6269 22.3473 14.9674Z",
    fill: "#16C1F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 7.92767C17.4317 7.92767 17.3667 7.92767 17.3008 7.93277C20.6742 8.04831 21.6043 11.3167 21.6043 15.3352C21.6043 18.048 20.8271 19.9808 19.3774 21.0963C18.4371 21.8202 18.0054 22.0665 17.3008 22.1005C17.365 22.1005 17.4309 22.1048 17.4993 22.1048C18.3906 22.1048 18.846 21.8805 19.9493 21.0963C21.5232 19.9808 22.3664 18.048 22.3664 15.3352C22.3697 11.2436 21.3255 7.92767 17.4993 7.92767Z",
    fill: "#ECA182",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.63 15.3352C12.63 11.2436 15.08 9.36942 15.08 9.36942C15.08 9.36942 16.0802 11.01 17.8679 11.5834C20.0399 12.2801 22.364 13.1365 22.364 15.3352C22.364 15.6199 23.8923 13.1373 23.8923 11.8035C23.8923 9.87492 22.5592 5.16394 17.4936 5.16394C11.6187 5.16394 10.9834 10.4526 10.9834 12.377C10.9834 13.8323 11.7826 15.1755 12.6595 16.2596C12.6426 15.9622 12.63 15.6547 12.63 15.3352Z",
    fill: "#243443"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0024 13.9716C21.2995 12.8604 19.6825 12.4424 18.0156 12.0584C15.9923 11.5911 15.2117 10.5767 15.2117 10.5767C15.2117 10.5767 12.6721 11.857 12.6654 16.2638C12.6426 15.9656 12.6299 15.6589 12.6299 15.3386C12.6299 11.2479 15.0799 9.37366 15.0799 9.37366C15.0799 9.37366 16.0802 11.0151 17.8678 11.5885C19.5254 12.1127 21.264 12.7346 22.0024 13.9716Z",
    fill: "#DB9172",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIconGeneric);
export default __webpack_public_path__ + "static/media/femaleIconGeneric.45a325a959fb8da2644d5fa66d7b82c2.svg";
export { ForwardRef as ReactComponent };